import { render, staticRenderFns } from "./GSelectAtendente.vue?vue&type=template&id=fb3ac754"
import script from "./GSelectAtendente.vue?vue&type=script&lang=js"
export * from "./GSelectAtendente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports